import { Component, OnInit } from '@angular/core';
import { Entry, JurorSelection } from '../entry';
import { EntryService } from '../entry.service';
import { ShowEntry } from '../show-entry';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.less']
})
export class ReportComponent implements OnInit {
  entries: Entry[];

  constructor(private entryService: EntryService) { }

  ngOnInit(): void {
    this.entries = this.entryService.entries;
    }

    strip(str: string): string {
      return str.replace(/,/g, '');
    }

    toShowEntry(entry: Entry): any {
      const showEntry = new ShowEntry();

      showEntry.SubmissionID = entry.submissionID;
      showEntry.JurorSelection = entry.jurorSelection;
      showEntry.FirstName = entry.raw.FirstName;
      showEntry.LastName = entry.raw.LastName;

      showEntry.City = entry.raw.City;
      showEntry.State = entry.raw.State;
      showEntry.Country = entry.raw.Country;

      if (entry.jurorSelection === 1) {
        showEntry.Title = entry.raw.Title1;
        showEntry.Price = Number(entry.raw.Price1);
        showEntry.UnframedWidth = entry.raw.UnframedWidth1;
        showEntry.UnframedHeight = entry.raw.UnframedHeight1;
        showEntry.Filename = entry.raw.Url1;
      } else if (entry.jurorSelection === 2) {
        showEntry.Title = entry.raw.Title2;
        showEntry.Price = Number(entry.raw.Price2);
        showEntry.UnframedWidth = entry.raw.UnframedWidth2;
        showEntry.UnframedHeight = entry.raw.UnframedHeight2;
        showEntry.Filename = entry.raw.Url2;
      }

      return showEntry;
    }
}
